import { render, staticRenderFns } from "./VueSelect.vue?vue&type=template&id=c02a15b8&"
import script from "./VueSelect.vue?vue&type=script&lang=js&"
export * from "./VueSelect.vue?vue&type=script&lang=js&"
import style0 from "./VueSelect.vue?vue&type=style&index=0&id=c02a15b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports